import { Component, ViewChild } from '@angular/core';
import { FadeInLeft } from 'src/app/animations/FadeInLeft';
import { Category } from 'src/app/models/Category';
import { UserType } from 'src/app/modules/auth/models/UserType';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { PreloadAndMulticastService } from 'src/app/services/preload-and-multicast.service';
import { RouterService } from 'src/app/services/router-service.service';
import { CartService } from 'src/app/modules/cart/services/cart.service';
import { eLegalEntityType } from 'src/app/modules/auth/classes/eLegalEntityType';
import { eMyPurchasesPageTabString } from 'src/app/modules/my-purchases/classes/eMyPurchasesPageTab';
import { eMySalesPageTabString } from 'src/app/modules/my-sales/classes/eMySalesPageTab';
import { Notification } from 'src/app/models/Notification';
import { NotificationsService } from 'src/app/services/notifications.service';
import { MatSnackBarService } from 'src/app/services/mat-snack-bar.service';
import { NotificationsPanelComponent } from '../notifications-panel/notifications-panel.component';

@Component({
	selector: 'app-lower-header',
	templateUrl: './lower-header.component.html',
	styleUrls: ['./lower-header.component.scss'],
	animations: [FadeInLeft]
})
export class LowerHeaderComponent {

	categories! : Category[];
	user : UserType;
	notifications? : Notification[];
	cNotifications? : number;
	cartBadgeNumber! : number;
	eLegalEntityType = eLegalEntityType;

	eMyPurchasesPageTabString = eMyPurchasesPageTabString;
	eMySalesPageTabString = eMySalesPageTabString;

	@ViewChild("notificationsPanel") notificationsPanel! : NotificationsPanelComponent;

	constructor(private pam:PreloadAndMulticastService,
				public routerService:RouterService,
				private auth:AuthService,
				private cartService:CartService,
				private notificationsService:NotificationsService,
				private matSnackBarService:MatSnackBarService) {
		this.auth.oUser.subscribe((u)=> this.user = u);
		this.pam.oCategories.subscribe(c=> this.categories = c);
		this.pam.oNotifications.subscribe(nl=> {
			this.notifications = nl.notifications
			this.cNotifications = nl.count;
		});

		// Estas suscripciones a las notificaciones están acá en lugar de en NotificationsPanelComponent porque acá necesito el contador
		// entonces agarro las notificacióens y se las paso por input
		this.notificationsService.oMoreNotifications.subscribe(n=> {
			let nAux = [...n, ...this.notifications!];
			this.notifications = nAux.slice(0, 5);
			this.cNotifications! += n.length;
		});

		this.cartService.current.asObservable().subscribe((carts)=> {
			this.cartBadgeNumber = carts.reduce((partialSum, c) => partialSum + c.products.length, 0);
		});
	}

	logout() {
		this.auth.logout();
		this.routerService.toHome();
		this.matSnackBarService.show("neutral", "¡Hasta la próxima!");
	}

	onNotificationsOpened() {
		this.notificationsPanel.wrapper.nativeElement.focus();
	}
}
